import {resourcesSliceFactory} from "../../../../setup/redux/slice/resourcesSlice";

export const managersSlice = resourcesSliceFactory('managers');
